export default __webpack_public_path__ + "static/optical-adjustment-dont-8c8f0b21885fc0937fc80ea1592d9c6616f384df12d7ee8d50be10fba09c5e52.png";